import { ResponsiveGrid as AEMResponsiveGrid } from '@adobe/aem-react-editable-components';
import React from 'react';

import { ContentContainer } from '@/design-system/atoms/ContentContainer';
/**
 * Container width props
 * isFullWidth: true - 100% width with no padding
 * isContentWidth: true - max width for article pages
 */

export default class ArticleContainer extends AEMResponsiveGrid {
    /*
     * Overriding the @aem-react-editable-components method to pass in
     * 'aemNoDecoration={true}' property to suppress wrapper divs
     * aem-react-editable-components/src/components/Container.tsx
     */
    connectComponentWithItem(ChildComponent, itemProps, itemKey) {
        const itemPath = this.getItemPath(itemKey);
        const { analytics } = this.props;

        return (
            <ChildComponent
                {...itemProps}
                analytics={analytics}
                key={itemPath}
                cqPath={itemPath}
                isInEditor={this.props?.isInEditor}
                aemNoDecoration={true}
                containerProps={this.getItemComponentProps(itemProps, itemKey, itemPath)}
            />
        );
    }

    /*
     * Overriding the @aem-react-editable-components render to wrap
     * content in main element
     */
    render() {
        return (
            <ContentContainer isContentWidth {...this.containerProps}>
                {this.childComponents}
                {this.placeholderComponent}
            </ContentContainer>
        );
    }
}
